import { axiosApi } from "../../../../../api/dbAxios";

export const deleteUserRole = async (id: number) => {
  try {
    const response = await axiosApi.delete(`/roles/${id}/`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
